
  function openTab(evt, tabName) {
    // Declare all variables
    var i, tabcontent, tablinks;

    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      //tabcontent[i].style.display = "none";
      tabcontent[i].classList.add("hiddencontent");

    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    // Show the current tab, and add an "active" class to the button that opened the tab
    //document.getElementById(tabName).style.display = "block";
    document.getElementById(tabName).classList.remove("hiddencontent");
    evt.currentTarget.className += " active";
  }

  window.addEventListener("DOMContentLoaded", function() {
    var firstTabButton = document.getElementsByClassName("tablinks")[0];
    // Check if there is an anchor link in the URL¨
    if (window.location.hash) {
      var tabName = window.location.hash.substr(1); // Get the tab name from the anchor link
      var tabButton = document.querySelector('.tablinks[data-tab="' + tabName + '"]');

      if (tabButton) {
        // Trigger click event on the tab button associated with the anchor link
        tabButton.click();
      } else {
        // If the tab button doesn't exist, open the first tab by default
        if (firstTabButton) {
          firstTabButton.click();
        }
      }
    } else {
      // If no anchor link is present, open the first tab by default
      if (firstTabButton) {
        firstTabButton.click();
      }
    }
  });
